<div class="l-container u-margin-top-xl">
  <div class="l-grid l-grid--horizontal-center">
    <div class="l-grid__unit l-grid__unit--12of12@large">

      <div class="ask-question-page w-full max-w-[1100px] mx-auto px-4 md:px-6">
        <h1 class="c-h1">{{ 'MENU.ask_question' | translate }}</h1>

        <div class="info-section">
          <!-- Info Messages -->
          @if (isInternal()) {
            <div class="page-notice page-notice--warning">
              <i class="fa fa-exclamation-circle page-notice__icon"></i>
              <p class="page-notice__text">{{ 'ASK_QUESTION.employee_warning' | translate }}</p>
            </div>
          }
          <div class="page-notice page-notice--info">
            <i class="fa fa-info-circle page-notice__icon"></i>
            <p class="page-notice__text" [innerHTML]="'ASK_QUESTION.unemployment_info_url' | translate"></p>
          </div>

          <!-- Context Info -->
          <div class="context-bar flex flex-col py-4 md:py-3 mb-6 border-b">
            <!-- Email Row -->
            <div class="context-bar__row flex flex-col md:flex-row flex-wrap gap-4 md:gap-6">
              <div class="context-bar__item context-bar__item--inline flex flex-row flex-wrap items-center gap-y-1 gap-x-2 pb-0 border-b-0 md:border-r-0 md:pr-0">
                <span class="context-bar__label text-[1.6rem] normal-case">{{ 'ASK_QUESTION.reply_to' | translate }}</span>
                <span class="context-bar__value text-[1.6rem] font-semibold">{{ getFormValue('email') || '-' }}</span>
                <a [routerLink]="['/membership/personal-data']" [queryParams]="{ tab: 3 }" class="context-bar__link basis-full md:basis-auto mt-1 md:mt-0 text-[1.4rem] no-underline hover:underline">
                  {{ 'RECENT_INFOS.edit' | translate }}
                </a>
              </div>
            </div>
            <!-- Payment Info Row -->
            @if (paymentDataState$ | async; as paymentData) {
              @if (!paymentData.loading && (paymentData.data?.paymentMoment || paymentData.data?.unemploymentPaymentRequest)) {
                <div class="context-bar__row context-bar__row--secondary flex flex-col md:flex-row flex-wrap gap-4 md:gap-6 mt-4 pt-4 border-t">
                  @if (paymentData.data?.paymentMoment) {
                    <div class="context-bar__item flex flex-col gap-1 pr-0 md:pr-6 pb-4 md:pb-0 border-b md:border-b-0 md:border-r last:border-b-0 last:pb-0 last:md:border-r-0 last:md:pr-0">
                      <span class="context-bar__label text-[1.4rem] uppercase tracking-wide">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.last_payment' | translate }}</span>
                      <a routerLink="/unemployment/payments" class="context-bar__value context-bar__value--link text-[1.7rem] md:text-[1.6rem] font-semibold no-underline hover:underline">
                        {{ paymentData.data.paymentMoment.dateOfPayment | date:'dd/MM/yyyy' }}
                      </a>
                    </div>
                  }
                  @if (paymentData.data?.unemploymentPaymentRequest) {
                    <div class="context-bar__item flex flex-col gap-1 pr-0 md:pr-6 pb-4 md:pb-0 border-b md:border-b-0 md:border-r last:border-b-0 last:pb-0 last:md:border-r-0 last:md:pr-0">
                      <span class="context-bar__label text-[1.4rem] uppercase tracking-wide">{{ 'PERSONAL_DATA.PERSONAL_INFORMATION.last_request' | translate }}</span>
                      <a routerLink="/unemployment/requests" class="context-bar__value context-bar__value--link text-[1.7rem] md:text-[1.6rem] font-semibold no-underline hover:underline">
                        {{ paymentData.data.unemploymentPaymentRequest.requestDate | date:'dd/MM/yyyy' }}
                      </a>
                    </div>
                  }
                </div>
              }
            }
          </div>

          <!-- Form -->
          <div class="form-card pt-2">
            <form [formGroup]="questionForm">

              <div class="form-group mb-6">
                <label class="form-label block text-[1.7rem] font-medium mb-2" for="question-subject">
                  {{ 'ASK_QUESTION.subject' | translate }}
                  <span class="form-required ml-1">*</span>
                </label>
                <p-select
                  inputId="question-subject"
                  [options]="selectData()"
                  formControlName="subject"
                  optionLabel="label"
                  optionValue="value"
                  [placeholder]="selectOptions().placeholder"
                  [showClear]="false"
                  [virtualScroll]="false"
                  [scrollHeight]="'300px'"
                  styleClass="form-select-dropdown"
                  panelStyleClass="form-select-panel">
                </p-select>
              </div>

              <div class="form-group mb-6">
                <label class="form-label block text-[1.7rem] font-medium mb-2" for="question-content">
                  {{ 'ASK_QUESTION.content' | translate }}
                  <span class="form-required ml-1">*</span>
                </label>
                <textarea id="question-content" class="form-textarea w-full p-5 text-[1.7rem] md:text-[1.7rem] leading-relaxed font-[inherit] rounded-lg resize-y min-h-[200px] transition-all duration-200 border" formControlName="content" rows="8"
                  placeholder="{{ 'ASK_QUESTION.content' | translate }}..."
                  [class.form-textarea--error]="questionForm.get('content')?.touched && questionForm.get('content')?.invalid"></textarea>
              </div>

              <div class="form-group mb-6">
                <label class="form-label block text-[1.7rem] font-medium mb-2" for="file-input">{{ 'ASK_QUESTION.add_attachment' | translate }} (Max {{ this.maxFilesize | fileSize }})</label>
                <div class="file-upload flex flex-col md:flex-row flex-wrap items-start md:items-center gap-4">
                  <input #fileInput type="file" accept="image/*, application/pdf" (change)="onNativeFileChange($event)" id="file-input" class="hidden">
                  <label for="file-input" class="file-upload__button inline-flex items-center gap-2 py-3 px-5 text-[1.6rem] rounded-md cursor-pointer transition-all duration-200 border">
                    <i class="fa fa-paperclip"></i>
                    {{ 'ASK_QUESTION.select_a_file' | translate }}
                  </label>
                  @if (selectedFileName()) {
                    <span class="file-upload__name text-[1.6rem]">{{ selectedFileName() }}</span>
                    <button type="button" class="file-upload__remove inline-flex items-center justify-center w-[2.8rem] h-[2.8rem] p-0 text-[1.4rem] rounded-full cursor-pointer transition-all duration-200 border bg-transparent" (click)="onResetFile()" title="{{ 'ASK_QUESTION.remove_file' | translate }}">
                      <i class="fa fa-times"></i>
                    </button>
                  } @else {
                    <span class="file-upload__name text-[1.6rem]">{{ 'ASK_QUESTION.no_file_selected' | translate }}</span>
                  }
                </div>
              </div>

              <div class="form-group form-group--checkbox flex items-center md:items-start gap-3 my-6">
                <input type="checkbox" class="form-checkbox w-6 h-6 m-0 cursor-pointer shrink-0 md:mt-1" formControlName="permission" id="permission">
                <label for="permission" class="form-checkbox-label text-[1.6rem] leading-snug cursor-pointer">{{ 'ASK_QUESTION.permission' | translate }}</label>
              </div>

              @if (missingDataMessage()) {
                <div class="form-error flex items-start gap-2 p-4 mb-6 text-[1.6rem] rounded-md">
                  <i class="fa fa-exclamation-circle shrink-0 mt-0.5"></i>
                  <span>{{ missingDataMessage() }}
                    @if (missingDataHasLink()) {
                      <a routerLink="/membership/personal-information" class="link-class">{{ 'ASK_QUESTION.email_missing_link' | translate }}</a>
                    }
                  </span>
                </div>
              }

              <button type="submit" class="form-submit inline-flex items-center justify-center gap-3 w-full py-5 md:py-[1.25rem] px-6 md:px-8 text-[1.7rem] md:text-[1.8rem] font-semibold text-white rounded-lg cursor-pointer transition-all duration-200 border-0" [disabled]="isLoading() || isInternal()" (click)="checkFormAndSubmit()">
                <span [style.display]="isLoading() ? 'inline' : 'none'"><i class="fa fa-spinner fa-spin text-[1.6rem]"></i></span>
                <span [style.display]="isLoading() ? 'none' : 'inline'"><i class="fa fa-paper-plane text-[1.6rem]"></i></span>
                {{ 'ASK_QUESTION.send_form' | translate }}
              </button>

            </form>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>
